export  default  {
    // 一级
    homePage: "Home Page",
    系统管理: "System Manage",
    系统监控: "System Monitoring",
    系统工具: "System Tools",
    // 二级
    日志管理: "Log Manage",
    用户管理: "User Manage",
    角色管理: "Role Manage",
    菜单管理: "Menu Manage",
    部门管理: "Dept Manage",
    岗位管理: "Jobs Manage",
    字典管理: "Dict Manage",
    参数设置: "Param Setting",
    通知公告: "Announcements",
    操作日志: "Operation log",
    登录日志: "Login log",
    定时任务: "Timing task",
    表单构建: "Form Building",
    代码生成: "Code Generate",
    系统接口: "System Interface",
    Sentinel控制台:"Sentinel Console",
    Nacos控制台:"Nacos Console",
    Admin控制台:"Admin Console",

}
